import WarrantyListPanel from './warrantyListPanel.container';

export default WarrantyListPanel;